import { ticketProvider } from "./providers/ticket";
import {
  parseTicketAttachmentResponse,
  parseTicketCreateResponse,
  parseTicketListResponse,
  parseTicketMessageListResponse,
  parseTicketMessageSendResponse,
  parseTicketSummaryResponse,
  parseTicketMessagePollResponse,
  validateTicketAttachmentRequest,
  validateTicketCreateRequest,
  validateTicketListRequest,
  validateTicketMessageEditRequest,
  validateTicketMessageListRequest,
  validateTicketMessagePollRequest,
  validateTicketMessageSendRequest,
} from "./schemas/ticketSchemas";
import { mapTicketListItem } from "./ticketUtils";

function normalizeListResponseBody(body) {
  if (!body || typeof body !== "object") return {};
  return {
    ...body,
    totalCount: body.totalCount != null ? Number(body.totalCount) : 0,
    page: body.page != null ? Number(body.page) : 0,
    size: body.size != null ? Number(body.size) : 0,
    items: Array.isArray(body.items) ? body.items : [],
  };
}

const ticketService = {
  createTicket: async (payload) => {
    const validated = validateTicketCreateRequest(payload);
    const response = await ticketProvider.createTicket(validated);
    return parseTicketCreateResponse(response?.data);
  },

  listTickets: async (data) => {
    const payload = validateTicketListRequest(data);
    const response = await ticketProvider.listTickets(payload);
    const body = normalizeListResponseBody(response?.data);
    const parsed = parseTicketListResponse(body);
    return {
      ...parsed,
      items: parsed.items.map(mapTicketListItem),
    };
  },

  sendMessage: async (data) => {
    const validated = validateTicketMessageSendRequest(data);
    const response = await ticketProvider.sendMessage(validated);
    return parseTicketMessageSendResponse(response?.data);
  },

  listMessages: async (data) => {
    const payload = validateTicketMessageListRequest(data);
    const response = await ticketProvider.listMessages(payload);
    const body = normalizeListResponseBody(response?.data);
    return parseTicketMessageListResponse(body);
  },

  downloadAttachment: async (data) => {
    const payload = validateTicketAttachmentRequest(data);
    const response = await ticketProvider.downloadAttachment(payload);
    return parseTicketAttachmentResponse(response?.data);
  },

  editMessage: async (data) => {
    const payload = validateTicketMessageEditRequest(data);
    return ticketProvider.editMessage(payload);
  },

  getSummary: async (options) => {
    const response = await ticketProvider.getSummary(options);
    return parseTicketSummaryResponse(response?.data);
  },

  pollMessages: async (data, options) => {
    const payload = validateTicketMessagePollRequest(data);
    const response = await ticketProvider.pollMessages(payload, options);
    return parseTicketMessagePollResponse(response?.data);
  },
};

export default ticketService;
